import axios from 'axios'
import qs from 'qs'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import { ApiAccessLoginResult, ApiResult, AccessCredentials, ApiAccessCredentials } from 'Types'

const endpoint = {
  api: `${apiUrl.stable}/acesso`,
  web: '/conta/api'
}

export const login = (credentails: AccessCredentials): ApiResult<ApiAccessLoginResult> => {
  const url = `${endpoint.web}/login`

  const params: ApiAccessCredentials = qs.stringify(credentails)

  return axios.post(url, params)
}

export const logout = () => {
  const url = `${endpoint.web}/logout`

  return axios.put(url)
}

export const activateEmail = (email, verificationCode) => {
  const url = `${endpoint.api}/ativaremail`

  const data = { email, verificationCode }

  return axios.put(url, data)
}

export const logoutAfterCancellation = () => {
  const url = `${endpoint.web}/logout`

  const headers = { ...jsonWebToken.header }

  return axios.put(url, null, { headers })
}

export const recoverPassword = (email) => {
  const url = `${endpoint.api}/recuperarsenha`

  const params = { Email: email }

  return axios.get(url, { params })
}

export const updatePassword = (newPassword, verificationCode) => {
  const url = `${endpoint.api}/alterarsenha`

  const data = { verificationCode, newPassword }

  return axios.put(url, data)
}

export const updatePasswordAuthenticated = (newPassword) => {
  const url = `${endpoint.api}/alterar-senha-autenticado`

  const data = { newPassword }

  const headers = { ...jsonWebToken.header }

  return axios.post(url, data, { headers })
}

export const updateToken = () => {
  const url = `${endpoint.web}/atualizar-login-info`

  return axios.post(url)
}

export const getInfoTwoFactorAuth = () => {
  const url = `${endpoint.api}/doisfatores/opcoes`
  const headers = { ...jsonWebToken.header }

  return axios.get(url, {headers})
}

export const registerTokenSendingMethod = (verificationType, verificationBackupType) => {
  const url = `${endpoint.api}/doisfatores/registrar`
  const headers = { ...jsonWebToken.header }
  const data = {
    defaultOption: verificationType,
    backupOption: verificationBackupType,
  }

  return axios.post(url, data, {headers})
}

export const validateTokenTWoFactorAuth = (token) => {
  const url = `${endpoint.api}/doisfatores/ativar`
  const headers = { ...jsonWebToken.header }

  const data = {
    privateToken: token.private,
    publicToken: token.public
  }

  return axios.post(url, data, { headers })
}

export const disableTokenTWoFactorAuth = (email, password) => {
  const url = `${endpoint.api}/doisfatores/desativar`
  const headers = { ...jsonWebToken.header }

  const data = {
    email,
    password
  }

  return axios.post(url, data, { headers })
}

export const resendTokenTWoFactorAuth = () => {
  const url = `${endpoint.api}/doisfatores/reenviar`
  const headers = { ...jsonWebToken.header }

  return axios.post(url, {headers})
}

export const setBackupTokenTWoFactorAuth = (backupType: number) => {
  const url = `${endpoint.api}/doisfatores/backup`
  const headers = { ...jsonWebToken.header }
  const data = {
    option: backupType
  }
  return axios.post(url, data, {headers})
}

export const loginTokenTWoFactorAuth = (token, isBackup) => {

  const url = `${endpoint.api}/doisfatores/validar`
  const headers = { ...jsonWebToken.header }

  const data = {
    privateToken: token.private,
    publicToken: token.public,
    isBackup,
  }

  return axios.post(url, data, {headers})
}

export const acceptInvite = (acceptInfo) => {

  const url = `${endpoint.api}/convite/aceitar`
  const headers = { ...jsonWebToken.header }

  const data = acceptInfo

  return axios.post(url, data, {headers})
}

export const inviteRegister = (data) => {

  const url = `${endpoint.api}/convite/registrar`

  return axios.post(url, data)
}

export const getStatusTokenTWoFactorAuth = () => {
  const url = `${endpoint.api}/doisfatores/status`
  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const getSelectedTwoFactorOptions = () => {
  const url = `${endpoint.api}/doisfatores/opcao-selecionada`
  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const sendTokenToLogin = (isBackup = false) => {
  const url = `${endpoint.api}/doisfatores/enviar-token`
  const headers = { ...jsonWebToken.header }

  const data = { sendToBackup: isBackup }

  return axios.put(url, data, { headers })
}

export default {
  login,
  logout,
  activateEmail,
  recoverPassword,
  updatePassword,
  getSelectedTwoFactorOptions
}
